import * as routeData from "../../../services/RouteOptimization";
import { useQuery } from "@tanstack/react-query";

export const useTheRouteData = () => {
  const { data, isLoading, error } = useQuery(["route"], routeData.getTheRoute);

  return { data, loading: isLoading, error };
};

export const useTheRouteList = () => {
  const { data, isLoading, error } = useQuery(["client"], routeData.getTheRouteList);

  return { data, loading: isLoading, error };
};
